/* import __COLOCATED_TEMPLATE__ from './connect-shopify.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { post } from 'embercom/lib/ajax';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import { type ButtonType } from '@intercom/pulse/template-registry';

interface Args {
  buttonLabel?: string | undefined;
  buttonType: ButtonType;
  icon?: InterfaceIconName | undefined;
  subtle?: boolean | undefined;
  tooltipContent?: string | undefined;
  reconnect?: boolean;
  shopifyDomain?: string;
}

export default class ConnectShopify extends Component<Args> {
  @service intl: any;
  @service store: any;
  @service notificationsService: any;
  @service intercomEventService: any;
  @service redirectService: any;
  @service appService: any;

  @task({ drop: true })
  *connectShopifyTask(): TaskGenerator<void> {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'connect_shopify_store_button',
      section: 'app_settings',
      context: 'shopify',
      place: 'settings',
    });
    try {
      let response = yield post('/ember/shopify/integrations', {
        app_id: this.appService.app.id,
        admin_id: this.appService.app.currentAdmin.id,
        reconnect: this.args.reconnect ?? false,
        shopify_domain: this.args.reconnect ? this.args.shopifyDomain : undefined,
      });
      this.redirectService.redirect(response.url);
    } catch (e) {
      this.notificationsService.notifyResponseError(e, {
        default: this.intl.t('appstore.settings.shopify.connect-shopify.connect-store-error'),
      });
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Appstore::AppPackage::Settings::Shopify::ConnectShopify': typeof ConnectShopify;
  }
}
